/**
 * Created by razial on 15.04.2026.
 */

const RewardedPromoWindow = Prefab.createWindow("rewarded_promo_window", "rewardedpromowindow_prefab_json", {
    bundles: (promotion) => ["crosspromo", promotion.getBundleName()].concat(typeof Families === "undefined" ? [] : Families.listLazyBundles(
        promotion.tasks.reduce((units, task) => units.concat(cleverapps.toArray(task.getRewards().units || [])), [])
    ))
});
